// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"4e735184","48":"1941550e","213":"a22fba40","281":"4ba95de6","318":"ca37bc94","325":"854b1884","421":"dd9073ae","462":"dda8968d","480":"92d156e6","501":"965047a9","655":"922f8d39","919":"1a32a2e7"}[chunkId] + ".chunk.js";
};